import { StyleEnums } from "models/enums";
import cssExports from "theme/styles/main.module.scss";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

const CSSHelper = {
  getClassByDisplayType: (displayType?: StyleEnums.DisplayType) => {
    switch (displayType) {
      case StyleEnums.DisplayType.Info:
        return cssExports.info;
      case StyleEnums.DisplayType.Success:
        return cssExports.success;
      case StyleEnums.DisplayType.Warning:
        return cssExports.warning;
      case StyleEnums.DisplayType.Danger:
        return cssExports.danger;
      case StyleEnums.DisplayType.None:
        return cssExports.neutral;
      default:
        return "";
    }
  },
  getTagClass: (status: StyleEnums.DisplayType) => {
    switch (status) {
      case StyleEnums.DisplayType.Info:
        return cssExports.blueTag;
      case StyleEnums.DisplayType.Success:
        return cssExports.greenTag;
      case StyleEnums.DisplayType.Warning:
        return cssExports.yellowTag;
      case StyleEnums.DisplayType.Danger:
        return cssExports.redTag;
      case StyleEnums.DisplayType.None:
        return cssExports.grayTag;
      default:
        return cssExports.grayTag;
    }
  },
  getDatePickerPopperClassByDisplayType: (displayType?: StyleEnums.DisplayType) => {
    switch (displayType) {
      case StyleEnums.DisplayType.Success:
        return "green";
      case StyleEnums.DisplayType.Warning:
        return "yellow";
      case StyleEnums.DisplayType.Danger:
        return "red";
      case StyleEnums.DisplayType.None:
        return "gray";
      case StyleEnums.DisplayType.Info:
      default:
        return "";
    }
  },

  convertWarningLevel: (level: WintSuperkollAPIModel.WarningLevel) => {
    switch (level) {
      case WintSuperkollAPIModel.WarningLevel.Error:
        return StyleEnums.DisplayType.Danger;
      case WintSuperkollAPIModel.WarningLevel.Warning:
        return StyleEnums.DisplayType.Warning;
      case WintSuperkollAPIModel.WarningLevel.Info:
        return StyleEnums.DisplayType.Info;
      case WintSuperkollAPIModel.WarningLevel.Success:
        return StyleEnums.DisplayType.Success;
      default:
        return StyleEnums.DisplayType.None;
    }
  },

  getLoginThemeRootClass: (theme: StyleEnums.DisplayType) => {
    switch (theme) {
      case StyleEnums.DisplayType.Info:
        return cssExports.loginTheme1;
      case StyleEnums.DisplayType.Warning:
        return cssExports.loginTheme2;
      default:
        return cssExports.loginTheme1;
    }
  },
  convertMSToNumber: (variableInMS: string) => {
    return Number(variableInMS.replace("ms", ""));
  },
};
export default CSSHelper;
